import plTranslations from './pl.js';
import enTranslations from './en.js';

export default {
  'pl': plTranslations,
  'en': enTranslations
};
